function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isUploadedFile } from '@prezly/uploads';
import { UPLOADCARE_CDN_URL } from "../constants.mjs";
import { normalizeFileName } from "./normalizeFileName.mjs";
export class UploadcareFile {
  static createFromPrezlyStoragePayload(payload) {
    return new UploadcareFile({
      uuid: payload.uuid,
      filename: payload.filename,
      mimeType: payload.mime_type,
      size: payload.size
    });
  }
  static createFromUploadcareWidgetPayload(payload) {
    return new UploadcareFile({
      uuid: payload.uuid,
      filename: payload.name,
      mimeType: payload.mimeType,
      size: payload.size
    });
  }
  static isPrezlyStoragePayload(payload) {
    return isUploadedFile(payload);
  }
  constructor(_ref) {
    var {
      filename,
      mimeType,
      size,
      uuid
    } = _ref;
    _defineProperty(this, "cdnUrl", void 0);
    _defineProperty(this, "downloadUrl", void 0);
    _defineProperty(this, "filename", void 0);
    _defineProperty(this, "mimeType", void 0);
    _defineProperty(this, "size", void 0);
    _defineProperty(this, "uuid", void 0);
    _defineProperty(this, "toPrezlyStoragePayload", () => ({
      version: 2,
      uuid: this.uuid,
      filename: this.filename,
      mime_type: this.mimeType,
      size: this.size
    }));
    this.uuid = uuid;
    this.filename = filename;
    this.size = size;
    this.mimeType = mimeType;
    this.cdnUrl = "".concat(UPLOADCARE_CDN_URL, "/").concat(uuid, "/").concat(encodeURIComponent(this.filename));
    this.downloadUrl = "".concat(UPLOADCARE_CDN_URL, "/").concat(uuid, "/-/inline/no/").concat(normalizeFileName(this.filename));
  }
  get isImage() {
    return this.mimeType.startsWith('image/');
  }
}